import React, { FC, HTMLProps } from "react";
import cn from "classnames";
import stl from "./index.module.scss";
import { AiFillWarning } from "react-icons/ai";

interface Props extends Omit<HTMLProps<HTMLDivElement>, "size"> {
  variant?: "error" | "success" | "info";
  size?: "small" | "medium" | "large";
}

const Alert: FC<Props> = ({
  variant = "info",
  className,
  children,
  size = "medium",
  ...props
}) => {
  const isError = variant === "error";
  const isSuccess = variant === "success";
  const isInfo = variant === "info";

  const isSmall = size === "small";
  const isMedium = size === "medium";
  const isLarge = size === "large";

  return (
    <div
      {...props}
      className={cn(className, stl.block, {
        [stl.error]: isError,
        [stl.success]: isSuccess,
        [stl.info]: isInfo,
        [stl.small]: isSmall,
        [stl.medium]: isMedium,
        [stl.large]: isLarge,
      })}
    >
      {isError && <AiFillWarning className={stl.icon} />}
      {children}
    </div>
  );
};

export default Alert;
